import { useState } from "react";
import { toast } from "sonner";
import { CalendarClock, UserRound, RefreshCw, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const fmtWhen = (s) => new Date(s).toLocaleString("id-ID", { dateStyle: "full", timeStyle: "short", timeZone: "Asia/Jakarta" });

export const SurveyInfo = ({ loan, onDone }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ reason: "", preferred_at: "" });
  const [busy, setBusy] = useState(false);
  const s = loan.survey?.schedule;
  if (loan.stage !== "survei" || !s) return null;
  const pending = loan.survey?.reschedule?.status === "pending";
  const send = async () => {
    if (f.reason.trim().length < 3) return toast.error("Tuliskan alasan jadwal ulang");
    setBusy(true);
    try {
      await api.post(`/loans/${loan.loan_id}/survey-reschedule`, { reason: f.reason.trim(), preferred_at: f.preferred_at ? new Date(f.preferred_at).toISOString() : null });
      toast.success("Permintaan jadwal ulang terkirim");
      setOpen(false);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 rounded-xl bg-amber-50 border border-amber-200 p-3" data-testid="member-survey-info">
      <div className="flex items-center gap-1.5 text-[13px] font-bold text-amber-900"><CalendarClock className="h-4 w-4" />Jadwal Survei Lapangan</div>
      <div className="text-[13px] text-slate-800 mt-1" data-testid="member-survey-date">{fmtWhen(s.scheduled_at)} WIB</div>
      <div className="text-[12px] text-slate-600 flex items-center gap-1"><UserRound className="h-3.5 w-3.5" />Petugas: {s.officer}</div>
      {s.note && <div className="text-[12px] text-slate-700 mt-0.5">{s.note}</div>}
      {pending ? <div className="text-[12px] text-amber-800 mt-2 font-semibold" data-testid="member-reschedule-pending">Permintaan jadwal ulang sedang diproses petugas.</div> : (
        <button onClick={() => setOpen(true)} data-testid="member-reschedule-button" className="mt-2 inline-flex items-center gap-1.5 text-[12px] font-bold text-blue-700 border border-blue-200 bg-white rounded-lg px-2.5 py-1.5">
          <RefreshCw className="h-3.5 w-3.5" />Minta Jadwal Ulang
        </button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="member-reschedule-dialog">
          <DialogHeader><DialogTitle>Minta Jadwal Ulang Survei</DialogTitle></DialogHeader>
          <textarea value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} rows={3} maxLength={300} placeholder="Alasan, misal: sedang bertugas di luar kota" data-testid="member-reschedule-reason"
            className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm" />
          <label className="text-xs text-slate-600">Usulan waktu (opsional)</label>
          <input type="datetime-local" value={f.preferred_at} onChange={(e) => setF({ ...f, preferred_at: e.target.value })} data-testid="member-reschedule-date" className="h-10 rounded-xl border border-slate-300 px-3 text-sm" />
          <button onClick={send} disabled={busy} data-testid="member-reschedule-submit" className="w-full flex items-center justify-center gap-2 bg-blue-700 text-white font-bold py-2.5 rounded-xl disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Kirim Permintaan
          </button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
